export class AttachmentRequest {
    fileName: string;
    key: string;
    fileSize: number;
    adminRequest: boolean;
}
